export default __webpack_public_path__ + "media/color/tnc-22971f00.svg";